import Modal from '@components/application/modal';
import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';

export interface BlackFridayBannerProps {
  variant: 'serps' | 'product';
}

const BlackFridayBanner = ({ variant }: BlackFridayBannerProps) => {
  const openModal = () =>
    EventEmitter.emit(EVENT_TYPES.openModal, `black-friday-modal`);
  const closeModal = () => EventEmitter.emit(EVENT_TYPES.closeModal);

  return (
    <>
      <div className="ac-promo ac-promo--black-friday ch-bg--black ch-color--white ch-flex-flow--column-nowrap sm:ch-flex-flow--row-nowrap">
        <div className="ac-promo__heading">
          <p className="ac-promo__title ch-mb--0 ch-text--uppercase ch-fw--800">
            {variant === 'serps' ? (
              <>
                Get an extra{' '}
                <span className="ch-color--ac-yellow">£500&nbsp;off</span> used
                cars
              </>
            ) : (
              <>
                Get an extra{' '}
                <span className="ch-color--ac-yellow">£500&nbsp;off</span> this
                car!
              </>
            )}
          </p>
        </div>
        <button
          className="ac-promo__link ch-color--white ch-fw--400 sm:ch-fs--3 ch-btn ch-btn--link ch-pa--0 sm:ch-ml--2"
          onClick={openModal}
          type="button"
        >
          Find out more
        </button>
      </div>
      <Modal hideClose id="black-friday-modal">
        <div className="ch-modal ch-modal--xs black-friday-modal">
          <div className="black-friday-modal__header">
            <button
              className="ch-modal__close"
              onClick={closeModal}
              type="button"
            >
              <span className="ch-reader">Close</span>
            </button>
            <div className="ch-display--flex ch-flex-direction--column ch-align-items--center ch-relative">
              <p className="ch-color--white ch-fs--8 ch-fw--800 ch-text--uppercase ch-mb--1 black-friday-modal__heading">
                Black <span>Friday</span>
              </p>
              <span className="ch-chip ch-chip--lg ch-chip--yellow ch-fw--800">
                Ends 7th December
              </span>
            </div>
          </div>
          <div className="ch-text--center ch-pa--3 ch-bg--white">
            <p className="ch-fs--4 ch-fw--600">£500 off!</p>
            <p className="ch-fs--3">
              Looking for your next car? Get an extra £500 off when buying a
              used or pre-registered car.*
            </p>
            <a
              className="ch-btn ch-btn--success ch-btn--sm ch-width--12 sl:ch-width--auto ch-mb--4"
              href="/black-friday"
              rel="nofollow"
            >
              Claim my voucher
            </a>
            <div>
              <a href="/terms" rel="nofollow">
                *Terms and conditions apply
              </a>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BlackFridayBanner;
